/**
 * forms.js — Универсальная логика форм для всех шаблонов Katabello.
 *
 * Требования к шаблону (см. temp_rules.md):
 * - Формы должны иметь класс .my-forms
 * - Внутри формы: input[type="tel"], .form__group, .form__error, button[type="submit"]
 * - Honeypot: input[name="message"] style="display:none"
 * - Скрытое поле: input[name="target"]
 * - Кнопки-источники: .track__button_js с data-source и data-whatsapp-text
 *
 * Глобальные переменные (задаются шаблоном перед подключением):
 * - window.KATABELLO_OBJECT_NAME — название объекта (H1)
 * - window.KATABELLO_LANG — язык страницы ('en', 'ru', ...)
 * - window.KATABELLO_DEFAULT_WA_TEXT — дефолтный текст для WhatsApp
 */
document.addEventListener('DOMContentLoaded', function() {

    // ============================================================
    // 1. ИНИЦИАЛИЗАЦИЯ ДАННЫХ ЗАЩИТЫ
    // ============================================================

    var entryTime = Date.now();

    var timezoneData = new Date().getTimezoneOffset();
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    var screenData = screenWidth + 'x' + screenHeight;
    var isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    var deviceType = (isMobileUA || screenWidth < 768) ? 'phone' : 'pc';
    var clientTime = new Date().toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });

    var objectName = window.KATABELLO_OBJECT_NAME || '';
    var pageLang = window.KATABELLO_LANG || 'en';
    var defaultWaText = window.KATABELLO_DEFAULT_WA_TEXT || '';

    // ============================================================
    // 1.1 ЛЕНИВАЯ ЗАГРУЗКА intl-tel-input
    // ============================================================
    // Библиотека нужна только в формах, которые лежат ниже первого экрана,
    // но раньше грузилась синхронно в <head> и блокировала отрисовку
    // примерно на 1.8 с. Теперь подтягиваем её при первом касании поля
    // телефона (focus) либо когда форма попадает во вьюпорт.
    var ITI_VERSION = '25.12.5';
    var ITI_BASE = 'https://cdn.jsdelivr.net/npm/intl-tel-input@' + ITI_VERSION + '/build/';
    var itiLoader = null;

    function loadIntlTelInput() {
        if (itiLoader) return itiLoader;

        itiLoader = new Promise(function(resolve, reject) {
            if (window.intlTelInput) {
                resolve(window.intlTelInput);
                return;
            }

            var css = document.createElement('link');
            css.rel = 'stylesheet';
            css.href = ITI_BASE + 'css/intlTelInput.css';
            document.head.appendChild(css);

            var script = document.createElement('script');
            script.src = ITI_BASE + 'js/intlTelInput.min.js';
            script.async = true;
            script.onload = function() {
                window.intlTelInput ? resolve(window.intlTelInput) : reject(new Error('intlTelInput missing'));
            };
            script.onerror = function() {
                reject(new Error('intlTelInput failed to load'));
            };
            document.head.appendChild(script);
        });

        return itiLoader;
    }

    // ============================================================
    // 2. ОТСЛЕЖИВАНИЕ ИСТОЧНИКА КЛИКА (LocalStorage)
    // ============================================================
    document.body.addEventListener('click', function(e) {
        var btn = e.target.closest('.track__button_js');

        if (btn) {
            var source = btn.getAttribute('data-source');
            var whatsappText = btn.getAttribute('data-whatsapp-text');
            if (source) {
                localStorage.setItem('lead_source', source);
            }
            if (whatsappText) {
                localStorage.setItem('lead_whatsapp_text', whatsappText);
            }
        }
    });

    // ============================================================
    // 3. ЛОГИКА ФОРМ (Валидация + Защита + Отправка)
    // ============================================================
    var forms = document.querySelectorAll('.my-forms');

    forms.forEach(function(form) {
        var phoneInput = form.querySelector('input[type="tel"]');
        var errorEl = form.querySelector('.form__error');
        var formGroup = phoneInput ? phoneInput.closest('.form__group') : null;
        var submitBtn = form.querySelector('button[type="submit"]');

        if (!phoneInput) return;

        // Определение страны по языку
        var fallbackCountry = pageLang === 'en' ? 'us' : (pageLang === 'zh' ? 'cn' : pageLang);

        // --- Инициализация intl-tel-input (по требованию) ---
        // iti остаётся null, пока библиотека не загрузится: до этого момента
        // поле работает как обычный tel-input, а проверка номера сводится
        // к минимальной. Так форма остаётся рабочей даже если CDN недоступен.
        var iti = null;
        var itiPending = null;

        function initIti() {
            if (itiPending) return itiPending;

            itiPending = loadIntlTelInput().then(function(factory) {
                if (iti) return iti;

                iti = factory(phoneInput, {
                    preferredCountries: ["ru", "us", "cn", "th", "fr", "de", "it", "es"],
                    initialCountry: "auto",
                    geoIpLookup: function(callback) {
                        fetch("https://ipapi.co/json/")
                            .then(function(response) { return response.json(); })
                            .catch(function() { return fetch("https://reallyfreegeoip.org/json/"); })
                            .then(function(response) { return response.json ? response.json() : response; })
                            .then(function(data) {
                                var countryCode = (data && data.country_code) ? data.country_code.toLowerCase() : "";
                                callback(countryCode || fallbackCountry);
                            })
                            .catch(function() {
                                callback(fallbackCountry);
                            });
                    },
                    loadUtils: function() { return import(ITI_BASE + "js/utils.js"); },
                    formatOnDisplay: true,
                    autoPlaceholder: "aggressive",
                    strictMode: true,
                    separateDialCode: true,
                    nationalMode: true,
                });

                return iti;
            }).catch(function() {
                // CDN недоступен — оставляем обычный input, форму не блокируем
                return null;
            });

            return itiPending;
        }

        // Первое касание поля — грузим библиотеку.
        // pointerdown срабатывает раньше focus и покрывает случай, когда
        // поле только что показали (в попапе) и пользователь сразу кликает
        phoneInput.addEventListener('pointerdown', initIti, { once: true });
        phoneInput.addEventListener('focus', initIti, { once: true });

        // Форма показалась на экране — грузим заранее, чтобы к моменту
        // клика по полю библиотека уже была готова.
        // Формы внутри попапов (#call-back и подобные) скрыты через
        // display:none, поэтому IntersectionObserver для них не сработает
        // никогда — их отслеживаем отдельно, ниже.
        var hidden = phoneInput.offsetParent === null;

        if ('IntersectionObserver' in window && !hidden) {
            var io = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        io.disconnect();
                        initIti();
                    }
                });
            }, { rootMargin: '200px' });
            io.observe(form);
        } else if (!hidden) {
            initIti();
        }

        if (hidden) {
            // Попап открывают кнопки с data-fancybox. Ждать конкретного
            // события библиотеки не будем — она может смениться; проще
            // отследить момент, когда форма стала видимой
            var reveal = function() {
                if (phoneInput.offsetParent === null) return;
                document.removeEventListener('click', onDocClick, true);
                if (revealObserver) revealObserver.disconnect();
                initIti();
            };

            var onDocClick = function(e) {
                if (!e.target.closest('[data-fancybox], [data-src="#call-back"]')) return;
                // Попап открывается не мгновенно — проверяем через кадр
                setTimeout(reveal, 150);
                setTimeout(reveal, 600);
            };

            document.addEventListener('click', onDocClick, true);

            // Подстраховка: если попап показали не кликом (таймером или
            // из кода), ловим появление формы в DOM-дереве
            var revealObserver = null;
            if ('MutationObserver' in window) {
                revealObserver = new MutationObserver(reveal);
                revealObserver.observe(document.body, {
                    attributes: true,
                    childList: true,
                    subtree: true,
                    attributeFilter: ['style', 'class'],
                });
            }
        }

        // --- Функция валидации ---
        function validatePhone() {
            if (errorEl) errorEl.classList.remove('show');
            if (formGroup) formGroup.classList.remove('error');

            if (phoneInput.value.trim() === "") return true;

            // Библиотека ещё не готова — проверяем по минимуму, чтобы
            // не отклонить валидный номер и не пропустить явный мусор
            if (!iti) {
                var digits = phoneInput.value.replace(/\D/g, '');
                if (digits.length >= 8) return true;

                if (errorEl) {
                    errorEl.textContent = "Invalid phone number";
                    errorEl.classList.add('show');
                }
                if (formGroup) formGroup.classList.add('error');
                return false;
            }

            if (!iti.isValidNumber()) {
                if (errorEl) {
                    errorEl.textContent = "Invalid phone number";
                    errorEl.classList.add('show');
                }
                if (formGroup) formGroup.classList.add('error');
                return false;
            }
            return true;
        }

        phoneInput.addEventListener('blur', validatePhone);
        phoneInput.addEventListener('focus', function() {
            if (errorEl) errorEl.classList.remove('show');
            if (formGroup) formGroup.classList.remove('error');
        });

        // --- ОТПРАВКА ФОРМЫ ---
        form.addEventListener('submit', function(e) {
            e.preventDefault();

            if (phoneInput.value.trim() === "") {
                if (errorEl) {
                    errorEl.textContent = "Please enter your phone number";
                    errorEl.classList.add('show');
                }
                if (formGroup) formGroup.classList.add('error');
                phoneInput.focus();
                return;
            }

            if (!validatePhone()) {
                phoneInput.focus();
                return;
            }

            if (submitBtn) submitBtn.disabled = true;

            // Библиотека форматирует номер в E.164. Если она не загрузилась,
            // отправляем то, что ввёл пользователь, — потерять заявку хуже,
            // чем принять номер в неканоническом виде
            var fullPhone = iti ? iti.getNumber() : phoneInput.value.trim();
            var formData = new FormData(form);

            formData.set(phoneInput.getAttribute('name') || 'phone', fullPhone);

            // === ДАННЫЕ ЗАЩИТЫ ===
            var currentSeconds = Math.round((Date.now() - entryTime) / 1000);

            formData.append('u_screen', screenData);
            formData.append('u_device_type', deviceType);
            formData.append('u_timezone', timezoneData);
            formData.append('client_time', clientTime);
            formData.append('u_seconds', currentSeconds);
            formData.append('object_name', objectName);

            // Язык страницы. Без него fn.php подставлял 'ru' по умолчанию,
            // и все заявки приходили как русскоязычные независимо от того,
            // с какой языковой версии их оставили
            formData.set('lang', pageLang);


    /**
     * Код визита из куки, которую ставит pactandai-widget.js при клике по кнопке WhatsApp.
     * Формат SM7K2 проверяется на месте: буква площадки, буква, три символа с обязательной
     * цифрой. Проверка нужна, чтобы битая кука не уехала в текст сообщения и в заявку.
     * Правило то же, что в виджете, в gateway и в CHECK базы — расходиться им нельзя.
     */
    function pactandaiVisitCode() {
        var m = document.cookie.match(/(?:^|; )pactandai_visit_code=([^;]*)/);
        if (!m) return '';
        var code = decodeURIComponent(m[1]);
        return (/^[SGY][A-HJ-KM-NP-Z][A-HJ-KM-NP-Z2-9]{3}$/.test(code) && /[2-9]/.test(code.slice(2)))
            ? code : '';
    }

    /**
     * Вставляет код визита в текст перед описанием объекта — там он читается как артикул
     * недвижимости, а не как метка, и его реже стирают.
     *
     * Якорь — эмодзи источника, если он в тексте есть: код обязан встать ПОСЛЕ него,
     * иначе они поменяются местами и код уедет от названия объекта. Эмодзи в этот путь
     * попадает не всегда (виджет его сюда не вставляет), поэтому есть и запасной якорь.
     */
    function injectVisitCode(message, code, objectName) {
        if (!message || !code || message.indexOf(code) !== -1) return message;

        // Формат текста (промокод со скидкой из блока акции) живёт в виджете — берём
        // его оттуда. Ниже — запасной путь на случай, если виджет не загрузился.
        if (typeof window.pactandaiInjectVisitCode === 'function') {
            return window.pactandaiInjectVisitCode(message, code, objectName);
        }

        // Главный путь: код встаёт вплотную ПЕРЕД названием объекта — там он читается
        // как артикул недвижимости. Название приходит из формы (objectName), потому что
        // угадать границу объекта по тексту нельзя: в каталоге это «1 Bedroom S 28м²
        // The Title Sierra», а на главной — только «The Title Sierra».
        if (objectName) {
            var at = message.indexOf(objectName);
            if (at > 0) {
                return message.slice(0, at) + code + ' ' + message.slice(at);
            }
        }

        var emoji = window.DOMAIN_EMOJI || '';
        if (emoji && message.indexOf(emoji) !== -1) {
            return message.replace(emoji, emoji + ' ' + code);
        }
        // Приветствие оканчивается на «!» или «！» — ставим код сразу за ним.
        var m = message.match(/^([^!！]*[!！])\s*/);
        if (m) {
            return m[0] + code + ' ' + message.slice(m[0].length);
        }
        return code + ' ' + message;
    }

            // === ПОДСТАНОВКА ИСТОЧНИКА (TARGET) ===
            var currentTarget = formData.get('target');

            if (!currentTarget || currentTarget.trim() === "") {
                var storedSource = localStorage.getItem('lead_source');

                if (storedSource) {
                    formData.set('target', storedSource);
                } else {
                    formData.set('target', 'Popup (source unknown)');
                }
            }

            // === ТЕКСТ ДЛЯ WHATSAPP ===
            var storedWhatsappText = localStorage.getItem('lead_whatsapp_text') || defaultWaText;

            // === КОД ВИЗИТА (ADR-033 D-10) ===
            //
            // Это ВТОРОЙ путь в WhatsApp, и он идёт МИМО виджета: редирект ниже строится
            // прямо здесь, поэтому ни эмодзи, ни код сюда сами не попадают. Берём код из
            // куки, которую виджет положил при клике, и вставляем в текст — чтобы в CRM
            // сработал основной путь распознавания, по коду.
            //
            // ЗАПАСНОГО ПУТИ «ПРИВЯЗКА ПО ТЕЛЕФОНУ» ЗДЕСЬ ПОКА НЕТ, И ЭТО НЕ ЗАБЫВЧИВОСТЬ.
            // Заявка уходит не в gateway, а на register_lead.php (см. forms/fn.php:32),
            // и тот пересылает фиксированный список полей. Положить сюда visit_code
            // значило бы завести поле, которое никто не читает: оно потерялось бы на
            // первом же переходе. Путь достраивается вместе с приёмом на стороне
            // register_lead.php — отдельным решением.
            var visitCode = pactandaiVisitCode();
            if (visitCode) {
                // В заявку — для запасного пути: fn.php перешлёт пару «телефон + код»
                // нашей CRM, и клик свяжется с чатом даже если код из текста сотрут.
                formData.set('visit_code', visitCode);
                // В текст — для основного пути, распознавания по коду.
                storedWhatsappText = injectVisitCode(storedWhatsappText, visitCode, objectName);
            }

            // Отправка
            fetch('/fn', {
                    method: 'POST',
                    body: formData
                })
                .then(function(response) { return response.json(); })
                .then(function(data) {
                    if (data.success) {
                        localStorage.removeItem('lead_source');

                        // Редирект в WhatsApp через pactandai-widget. Если CRM недоступна
                        // (виджет не загрузился или не получил менеджера) — запасной
                        // менеджер из constants.php, иначе человек остался бы на странице
                        var agent = window.pactandaiAgent || window.PACTANDAI_FALLBACK_AGENT;
                        var phone = agent ? agent.whatsapp_phone : '';
                        if (phone) {
                            window.location.href = 'https://wa.me/' + phone.replace(/^\+/, '') + '?text=' + encodeURIComponent(storedWhatsappText);
                        }
                    } else {
                        if (submitBtn) submitBtn.disabled = false;
                        alert(data.message || "Error");

                        if (data.type === 'format' && errorEl) {
                            errorEl.textContent = data.message;
                            errorEl.classList.add('show');
                            if (formGroup) formGroup.classList.add('error');
                        }
                    }
                })
                .catch(function(error) {
                    console.error('Fetch error:', error);
                    if (submitBtn) submitBtn.disabled = false;
                    alert("Connection error");
                });
        });
    });
});
